module.exports = __webpack_public_path__ + "static/media/cover-turkey.d6d0e22e.jpg";